<div class="container">
    <div [id]="id" class="section" tabindex="0"
        (click)="toggle($event)"
        (keydown.enter)="toggle($event)"
        role="button"
        [attr.aria-expanded]="expanded"
        [attr.aria-controls]="id + '-content'"
        [attr.aria-label]="ariaLabel">
        <div class="header">
            <finder-font-icon size="inherit"
                class="icon {{iconOpened}}"
                [ngClass]="{'visible': expanded}"
                [name]="iconOpened">
            </finder-font-icon>
            <finder-font-icon size="inherit"
                class="icon {{iconClosed}}"
                [ngClass]="{'visible': !expanded}"
                [name]="iconClosed">
            </finder-font-icon>
            <finder-font-icon class="header-icon" *ngIf="headerIcon" size="inherit"
                [name]="headerIcon">
            </finder-font-icon>
            <h3 class="title">{{title}}</h3>
        </div>
    </div>
    <div #contentElement class="content" [@sectionContent]="expanded ? 'expanded' : 'shrunk'" (@sectionContent.done)="onAnimationEvent($event)"
        role="region"
        [id]="id + '-content'"
        [attr.aria-labelledby]="id"
        [attr.aria-hidden]="!expanded">
            <ng-content></ng-content>
    </div>
</div>
